const breakpoints = {
  MOBILE: 414,
  TABLET: 1024,
  DESKTOP: 1025,
};

export default breakpoints;
